import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom'
import React from 'react'
import LogoutPage from '../pages/logout/LogoutPage'
import withSuspensePage from '../utils/withSuspensePage'

export type MyRouteComponentProps = RouteComponentProps<any> & {
  routes: Rout[]
}

interface Rout {
  path?: string[] | string
  component: React.ComponentType<MyRouteComponentProps> | React.ComponentType<any>
  routes: Rout[]
  exact?: boolean
  strict?: boolean
}

const RedirectToLogin = () => <Redirect to={'/login'} />
const RedirectToDashboard = () => <Redirect to={'/dashboard'} />

const Routes: Rout[] = [
  {
    path: ['/login'],
    component: withSuspensePage(React.lazy(() => import(/* webpackChunkName: "login" */ 'pages/login/LoginPage'))),
    routes: [],
  },
  {
    path: '/dashboard',
    component: withSuspensePage(
      React.lazy(() => import(/* webpackChunkName: "dashboard" */ 'pages/dashboard/DashboardPage')),
    ),
    routes: [
      {
        path: '/dashboard',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "blank" */ 'pages/dashboard/blank/BlankPage')),
        ),
        routes: [],
        exact: true,
      },
      {
        path: '/dashboard/movements',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "movements" */ 'pages/dashboard/movements/MovementsPage')),
        ),
        routes: [],
      },
      {
        path: '/dashboard/stock',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "stock" */ 'pages/dashboard/stock/StockPage')),
        ),
        routes: [],
      },
      {
        path: '/dashboard/bulk',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "bulk" */ 'pages/dashboard/bulk/BulkPetitionPage')),
        ),
        routes: [],
      },
      {
        path: '/dashboard/production',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "production" */ 'pages/dashboard/production/ProductionPage')),
        ),
        routes: [],
      },
      {
        path: '/dashboard/recoded-orders',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "recode" */ 'pages/dashboard/recode/RecodePage')),
        ),
        routes: [],
      },
      {
        path: '/dashboard/repackaged-orders',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "repackage" */ 'pages/dashboard/repackage/RepackagePage')),
        ),
        routes: [],
      },
      {
        path: '/dashboard/crossdock-orders',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "crossdock" */ 'pages/dashboard/crossdock/CrossdockPage')),
        ),
        routes: [],
      },
      {
        path: '/dashboard/quality-processes',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "quality" */ 'pages/dashboard/quality/QualityPage')),
        ),
        routes: [],
      },
      {
        path: '/dashboard/shipments',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "shipments" */ 'pages/dashboard/shipments/ShipmentsPage')),
        ),
        routes: [],
      },
      {
        path: '/dashboard/customers',
        component: withSuspensePage(
          React.lazy(() => import(/* webpackChunkName: "customers" */ 'pages/dashboard/customers/CustomersPage')),
        ),
        routes: [],
      },
      {
        path: '*',
        component: RedirectToDashboard,
        routes: [],
      },
    ],
  },
  {
    path: '/logout',
    component: LogoutPage,
    routes: [],
  },
  {
    path: '*',
    component: RedirectToLogin,
    routes: [],
    exact: true,
  },
]

export const RouteWithSubRoutes: React.FC<Rout> = route => {
  return <Route
    path={route.path}
    render={props => <route.component
      {...props}
      routes={route.routes} />} />
}

export const RoutesConfig: React.FC = () => {
  return (
    <Switch>
      {Routes.map((rout, index) => {
        return <RouteWithSubRoutes
          key={index}
          {...rout} />
      })}
    </Switch>
  )
}
